import http from "../http";

const apiUrl = `${process.env.REACT_APP_API_URL}offline-transactions`;

export function getOfflineTransactions(params) {
  return http.get(apiUrl, { params });
}

export function getOfflineTransaction(id) {
  return http.get(`${apiUrl}/${id}`);
}

export function saveOfflineTransaction(data) {
  if (data.id) return http.patch(`${apiUrl}/${data.id}`, data);
  return http.post(apiUrl, data);
}

export function uploadOfflineTransactionScanCopy(transactionId, file) {
  const formData = new FormData();
  formData.append("file", file);

  return http.post(`${apiUrl}/upload-scan-copy/${transactionId}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}
 
export function deleteOfflineTransaction(id) {
  return http.delete(`${apiUrl}/${id}`);
}
